<div class="policy-details">
  <div class="policy-details__content">
    <div *ngIf="isAdvisor" class="policy-details__header-container">
      <div class="policy-details__header-item">Individual Life Insurance Application for&nbsp;</div>
      <div class="policy-details__header-item">
        {{ applicantName }}
      </div>
    </div>
    <div *ngIf="!isAdvisor" class="policy-details__header-container">
      <div *ngIf="shouldShowFlAdvisorDetails" class="policy-details__agent-container">
        <div class="policy-details__header-item-secondary--applicant">Insurance Producer: {{ advisorName }}</div>
        <div *ngIf="licenseNumber" class="policy-details__header-item-secondary--applicant">
          Florida License Number: {{ licenseNumber }}
        </div>
      </div>
      <div class="policy-details__header-item-secondary">Massachusetts Mutual Life Insurance Company</div>
      <div class="policy-details__header-item-secondary--applicant">Home Office: {{ homeOfficeAddress }}</div>
      <div class="policy-details__header-item-secondary--applicant">
        Administrative Office: {{ adminOfficeAddress }}
      </div>
      <div class="policy-details__header-item-secondary--applicant">
        Individual Life Insurance Application for {{ insuredName }}
      </div>
    </div>
    <div class="policy-details__summary">
      <div *ngIf="isAdvisor">
        <div *ngIf="shouldShowFlAdvisorDetails" class="policy-details__agent-container">
          <div class="policy-details__header-item-secondary--applicant">Insurance Producer: {{ advisorName }}</div>
          <div *ngIf="licenseNumber" class="policy-details__header-item-secondary--applicant">
            Florida License Number: {{ licenseNumber }}
          </div>
        </div>
        <div class="policy-details__mm-text">Massachusetts Mutual Life Insurance Company</div>
        <div class="policy-details__header-item-secondary--applicant">Home Office: {{ homeOfficeAddress }}</div>
        <div class="policy-details__header-item-secondary--applicant">
          Administrative Office: {{ adminOfficeAddress }}
        </div>
      </div>
      <div class="policy-info">
        <div class="policy-info__layout-container">
          <div class="policy-info__layout-item policy-info__layout-item--top">
            <div class="policy-info__item policy-info__item--policy">
              <div class="policy-info__value">
                {{ filingNumber }}
              </div>
              <div class="hidden-tablet-up">&nbsp;</div>
              <div class="policy-info__label">Filing No.</div>
            </div>
          </div>

          <div class="policy-info__divider hidden-mobile"></div>

          <div class="policy-info__layout-item policy-info__layout-item--bottom">
            <div class="policy-info__item policy-info__item--coverage">
              <div class="policy-info__value">
                {{ formattedCoverageAmount }}
              </div>
              <div class="hidden-tablet-up">&nbsp;</div>
              <div class="policy-info__label">Coverage</div>
            </div>
            <div class="policy-info__divider hidden-mobile"></div>
            <div class="policy-info__layout-item--lastrow">
              <div class="policy-info__item policy-info__item--term">
                <div class="policy-info__value">
                  {{ lengthType }}
                </div>
                <div class="hidden-tablet-up">&nbsp;</div>
                <div class="policy-info__label">
                  {{ productType }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
